<template>
  <Modal :styles="{top: '20px',width:'95%'}"  title="合同选择"   v-model="addflag" :footer-hide="true">
             <Row type="flex" justify="start" align="middle" :gutter="16">
                    <Col>
                    <Button  type="primary" style="width:80px" long @click="doFilterSearch">查询</Button>
                    </Col>
                     <Col>
                        <Button  type="primary" style="width:80px" long @click="doOk">确定</Button>
                    </Col>
                    <Col>
                        <Button  style="width:80px" long @click="doClearFilter">重置</Button>
                    </Col>
                    <Col>
                    <Button  style="width:80px" @click="cancelFilter">关闭</Button>
                    </Col>
            </Row>
            <Card  :padding="5"  dis-hover :bordered="false"  style="margin-bottom: 5px;">
                <BillConditionsBox ref='quick' :config="contSearchFormConfig" :dictData="dictData" modeType="two"></BillConditionsBox>
            </Card>
            <ViewGrid ref="cont" :config="contSearchGridConfig" :dictData="dictData" @dbclick="dbclick"/>
    </Modal>
</template>

<script>
export default {
    name:'contractsearch',
    data () {
        return {
            addflag:false,
            contSearchGridConfig:{
                resources: this.OmdUrl.mall,
                method: 'mall.work.cont.search',
                responseCode: 'contno',
                responseName: 'contno',
                labelWidth: 70,
                width: 0.65,
                height:270,
                response: 'contmain',
                multiSelect: false,
                searchParam: {
                    order_field: 'contno',
                },
                items: [
                    {
                        label: '合同号',
                        name: 'contno',
                        type: 'TextBox',
                        sortable: true,
                        condition: true,
                        width: 180,
                        tooltip: true,
                    }, {
                        label: '合同状态',
                        name: 'contstatus',
                        type: 'ComboBox',
                        sortable: true,
                        dictkey:'CONTRACT_CONTSTATUS',
                        width: 120,
                    },
                    {
                        label: '门店',
                        name: 'muid_name',
                        type: 'TextBox',
                        width: 220,
                        tooltip: true,
                    },
                    {
                        label: '商户',
                        name: 'sbid_name',
                        type: 'TextBox',
                        tooltip: true,
                    }
                ],
            },
            contSearchFormConfig:{
                lineNum:2,
                items:[{
                    label: '合同号',
                    name: 'contno',
                    type: 'TextBox',
                }, {
                    label: '合同状态',
                    name: 'contstatus',
                    type: 'ComboBox',
                    dictkey:'CONTRACT_CONTSTATUS',
                },
                {
                    label: '门店',
                    name: 'muid',
                    textName:'muid_name',
                    type: 'PopTextBox',
                    selectkey:'muid',
                },
                {
                    label: '商户',
                    name: 'sbid',
                    textName: 'sbid_name',
                    type: 'PopTextBox',
                    selectkey:'supmkt',
                },
                {
                    label: '品牌',
                    name: 'ppcode',
                    textName: 'ppcode_name',
                    type: 'PopTextBox',
                    selectkey:'ppcode',
                },
                {
                    label: '经营种类',
                    name: 'manatype',
                    dictkey:'COMPANY',
                    type: 'ComboBox'
                },{
                    label: '合同文本号',
                    name: 'contdocno',
                    type: 'TextBox',
                },{
                    label: '商铺',
                    name: 'contmanaframe:spid',
                    type: 'PopTextBox',
                    selectkey:'zlcmfspid',
                },{
                    label: '商品编码',
                    name: 'contgoods:gbid',
                    type: 'TextBox'
                }
                ]
            },
            searchParam:{

            }
        }; 
    },
    created () {
        this.init();
    },
    props:{
        config: {
            type:Object,
            default:null
        },
        dictData: {
            type: Object,
            default: () => {
                return {};      
            }
        },
    },
    methods: {
        init() {
            if (this.config) {
                if (this.config.formConfig) {
                    Object.assign(this.contSearchFormConfig, this.config.formConfig);
                }
                if (this.config.searchParam) {
                    Object.assign(this.searchParam, this.config.searchParam); 
                }
            }
        },
        show() {
            this.addflag = true;
            this.$refs.quick.clearData();
            this.$nextTick(() => {
              
                this.refurbish();
            });
        },
        doClearFilter() {
            this.$refs.quick.clearData();
            this.$refs.cont.refurbish();
        },
        cancelFilter() {
            this.addflag = false;
        },
        doFilterSearch() {
            this.refurbish();
        },
        getSearchParam() {
            let searchParam = Object.assign({},this.searchParam);
            if (!searchParam) {
                searchParam = {};
            }
            let tempSearchParam = {};
            let conditionSearchParam = this.$refs.quick.getQuerySearchParam();
            for (let el in searchParam) {
                if (conditionSearchParam[el]) {
                    tempSearchParam[el]={'$and':[]}; 
                    let temp = {};
                    temp[el] = searchParam[el];
                    tempSearchParam[el]['$and'].push(temp);
                    let temp2 = {};
                    temp2[el] = conditionSearchParam[el];
                    tempSearchParam[el]['$and'].push(temp2);
                }
            }
            searchParam = Object.assign({},searchParam,conditionSearchParam);
            for (let el in tempSearchParam) {
                searchParam['$and'] = this.$Method.copy(tempSearchParam[el]['$and']);
                delete searchParam[el];
            }
            return searchParam;
        },
        refurbish() {
            this.$refs.cont.clearSearchBeforeSearchParam();
            this.$refs.cont.setSearchBeforeSearchParam(this.getSearchParam());
            this.$refs.cont.refurbish();
        },
        dbclick(e) {
            this.addflag = false;
            let obj = {};
            obj.name = 'selectedContno';
            obj.para = e;
            this.$emit('doAction',obj);
        },
        doOk() {
            let data = this.$refs.cont.getSelection();
            if (data.length === 0) {
                this.alert('请选择合同');
                return false;
            } else {
                this.addflag = false;
                let obj = {};
                obj.name = 'selectedContno';
                obj.para = data[0];
                this.$emit('doAction', obj);
            }
        } 
    }
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/layouttemplate/contractsearch.vue